(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["button"] && !Shopify.designMode) return;
  try {
    function openShoppingMenu(event) {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-sg-shopping-menu]');
    if (!trigger || event.defaultPrevented) return;
    if (event.type === 'click' && (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return;
    if (event.type === 'keydown' && event.key !== ' ') return;

    const drawer = document.querySelector('header-drawer');
    const details = drawer?.querySelector('.menu-drawer-container');
    const summary = details?.querySelector(':scope > summary');
    const container = drawer?.closest('.header__drawer');
    if (!details || !summary || !container || !customElements.get('header-drawer')) return;

    event.preventDefault();
    event.stopPropagation();
    if (details.open) return;

    container.classList.add('sg-shopping-menu-open');
    trigger.setAttribute('aria-expanded', 'true');

    const restore = () => {
      if (details.open) return;
      container.classList.remove('sg-shopping-menu-open');
      trigger.setAttribute('aria-expanded', 'false');
      details.removeEventListener('toggle', restore);
      if (trigger.isConnected) trigger.focus({ preventScroll: true });
    };
    details.addEventListener('toggle', restore);
    summary.click();
    requestAnimationFrame(() => drawer.querySelector('.menu-drawer__close-button')?.focus({ preventScroll: true }));
  }

  document.addEventListener('click', openShoppingMenu, true);
  document.addEventListener('keydown', openShoppingMenu, true);
  } catch(e) { console.error(e); }
})();

})();
